import { SVGProps } from "react";

export const GirlIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={26}
    viewBox="0 0 13 26"
    fill="none"
    {...props}
  >
    <path
      fill="#FF95E1"
      d="M10.594 12.818c-.546-.984-1.217-1.781-1.888-2.337a4.692 4.692 0 0 1-2.775.917 4.697 4.697 0 0 1-2.779-.917c-.67.557-1.34 1.354-1.887 2.336-1.273 2.282-1.413 4.622-.315 5.23.492.274 1.008.07 1.541-.441-.099.55-.149 1.108-.149 1.668 0 2.61 1.02 4.726 2.275 4.726.757 0 1.132-.77 1.312-1.95.179 1.18.555 1.95 1.31 1.95 1.258 0 2.277-2.115 2.277-4.726 0-.588-.054-1.15-.15-1.668.534.51 1.05.715 1.543.441 1.1-.607.957-2.947-.314-5.23h-.001Zm-4.664-2.31a3.841 3.841 0 0 0 2.744-1.095 3.81 3.81 0 0 0 1.141-2.715 3.796 3.796 0 0 0-1.142-2.715A3.829 3.829 0 0 0 5.93 2.888a3.843 3.843 0 0 0-2.76 1.087 3.811 3.811 0 0 0-1.151 2.724 3.797 3.797 0 0 0 1.15 2.724 3.83 3.83 0 0 0 2.761 1.086Zm2.614-7.821c1.106.405.441-.646.441-1.363s.682-1.597-.44-1.24c-1.176.376-2.13.583-2.13 1.3 0 .718.954.87 2.131 1.303h-.002Zm-2.606-.512c.7 0 .308-.352.308-.787 0-.434.394-.786-.307-.786-.701 0-.335.353-.335.786 0 .437-.366.787.334.787Zm-2.623.512c1.177-.431 2.132-.583 2.132-1.3 0-.718-.955-.928-2.133-1.304-1.121-.358-.44.52-.44 1.238 0 .717-.665 1.768.44 1.364l.001.002Z"
    />
  </svg>
);
